import { SearchableListSelect } from './SearchableListSelect';
import { useEventTypes } from '../../hooks/useEvents';

export interface EventTypeSelectProps {
  /** Selected event type id (null = none). */
  value: string | null;
  onChange: (eventTypeId: string | null) => void;
  disabled?: boolean;
  placeholder?: string;
  ariaLabel?: string;
}

/** Searchable event type picker backed by the shared event types list. */
export function EventTypeSelect({
  value,
  onChange,
  disabled,
  placeholder = 'Any event type',
  ariaLabel = 'Event type',
}: EventTypeSelectProps) {
  const { data: eventTypes = [], isLoading } = useEventTypes();
  return (
    <SearchableListSelect
      items={eventTypes}
      value={value}
      onChange={(next) => onChange(typeof next === 'string' && next ? next : null)}
      getValue={(eventType) => eventType.id}
      getLabel={(eventType) => eventType.name}
      isLoading={isLoading}
      disabled={disabled}
      placeholder={placeholder}
      ariaLabel={ariaLabel}
    />
  );
}
